import InterestCalculationType from "@/models/Products/InterestCalculationType";

export default (interestCalulationType: InterestCalculationType) => {
    let returnVal = "Undefined";
    switch (interestCalulationType) {
        case InterestCalculationType.Flat:
            returnVal = "Flat"
            break;
        case InterestCalculationType.DecliningBalance:
            returnVal = "Declining Balance"
            break;
        case InterestCalculationType.DecliningBalanceEqualInstallments:
            returnVal = "Declining Balance Equal Installments"
            break;
    }
    return returnVal;
}